export enum BulkUploadStatus {
    Queued = 'Queued',
    Processing = 'Processing',
    Completed = 'Completed',
    Failed = 'Failed',
}
